import React, { useState, useEffect } from "react"

import BrowserLocationHelper from "../utils/browser_location_helper"
import { getInitialCartCount } from "../stores/CartStateStore"

import style from "./style.module"

export default function NavbarCartItem(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { venue_id, isStorePage, storeUrl } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [cartCount, setCartCount] = useState(getInitialCartCount(venue_id))

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    window.addEventListener("cart_count_changed", _onChange)

    return () => {
      window.removeEventListener("cart_count_changed", _onChange)
    }
  }, [])

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function _onChange(e) {
    setCartCount(e.detail || 0)
  }

  function goToStorePage() {
    BrowserLocationHelper.ChangeURL(storeUrl)
  }

  function showModal() {
    const event = new Event("show_cart")
    window.dispatchEvent(event)
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const callback = isStorePage || cartCount === 0 ? showModal : goToStorePage

  // -------------------------------------

  return (
    <div className={style.cartButton} title="Carrello" onClick={callback}>
      <span className={`fal fa-shopping-cart ${style.icon}`} />
      <span className={style.cartCount}>{cartCount}</span>
    </div>
  )
}
